import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from '../../shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

export type AccountSettingsCommand = 'reset_data' | 'reset_network' | 'delete_account'
@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  settings(command: AccountSettingsCommand): any {
    this.logger.debug('settings | credentials: ' + command)

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      command: command,
    }

    return this.http
      .post(`${Backend.HOST_CONTAINER + Backend.ACCOUNT}`, userData, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('settings | catchError | errorMessage: ' + errorMessage)
          return of(errorMessage)
        }),
      )
  }
}
